import React from "react";
import { statusCategory, CATEGORY_CLASSES, CATEGORY_DOT } from "../lib/statuses";

export function StatusBadge({ status, className = "", testId }) {
  const cat = statusCategory(status);
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${CATEGORY_CLASSES[cat]} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${CATEGORY_DOT[cat]}`} />
      {status}
    </span>
  );
}
